import { TextField } from '@material-ui/core';
import React from 'react';
import CommonModal from '../../../extras/commonModal';
import MenuItem from '@material-ui/core/MenuItem';
import MarkdownEditor from '@uiw/react-markdown-editor';
import {
  publishJobs,
  unPublishJobs,
  updateJobs,
} from '../../../services/apiService';
import StringArrayInput from './skillInput';
import { toast } from 'react-toastify';

const UpdateJobModal = ({
  isOpen,
  setIsOpen,
  currentSelected,
  filtersOptions,
  onGridReady,
  gridApi,
}) => {
  const [updatedJob, setUpdatedJob] = React.useState({});

  React.useEffect(() => {
    setUpdatedJob({
      jobId: currentSelected?.jobId,
      description: currentSelected?.description,
      companyName: currentSelected?.companyName,
      domain: currentSelected?.domain,
      locationRequirement: currentSelected?.locationRequirement,
      title: currentSelected?.title,
      location: currentSelected?.location,
      employmentType: currentSelected?.employmentType,
      minExperienceRequired: currentSelected?.minExperienceRequired,
      maxExperienceRequired: currentSelected?.maxExperienceRequired,
      minSalary: currentSelected?.minSalary,
      maxSalary: currentSelected?.maxSalary,
      skills: currentSelected?.skills,
    });
  }, [currentSelected]);

  const handleUpdateJob = async () => {
    try {
      const res = await updateJobs(updatedJob);
      if (res) {
        onGridReady(gridApi);
        setIsOpen(false);
        toast.success('Job updated successfully');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to update job');
    }
  };

  return (
    <CommonModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      removePadding
      classStyle='w-11/12 h-5/6 rounded-md overflow-y-auto'
    >
      <div className='m-6'>
        <div>
          {currentSelected?.publishedAt ? (
            <div
              className='px-6 py-2 bg-brand-primary text-white rounded-md text-center inline-block cursor-pointer'
              onClick={async () => {
                try {
                  const apiData = {
                    jobId: currentSelected?.jobId,
                  };
                  const res = await unPublishJobs(apiData);
                  if (res?.successful) {
                    toast.success(res.message);
                    onGridReady(gridApi);
                    setIsOpen(false);
                  }
                } catch (error) {
                  toast.success('Some Error Occured');
                  console.error(error);
                }
              }}
            >
              Unpublish
            </div>
          ) : (
            <div
              className='px-6 py-2 bg-brand-primary text-white rounded-md text-center inline-block cursor-pointer'
              onClick={async () => {
                try {
                  const apiData = {
                    jobId: currentSelected?.jobId,
                  };
                  const res = await publishJobs(apiData);
                  if (res?.successful) {
                    toast.success(res.message);
                    onGridReady(gridApi);
                    setIsOpen(false);
                  }
                } catch (error) {
                  toast.success('Some Error Occured');
                  console.error(error);
                }
              }}
            >
              Publish
            </div>
          )}
        </div>
        <div className='grid grid-cols-2 gap-6 my-6'>
          <div className='col-span-2'>
            <MarkdownEditor
              value={updatedJob?.description}
              height='300px'
              onChange={(value, viewUpdate) =>
                setUpdatedJob((prev) => {
                  return { ...prev, description: value };
                })
              }
            />
          </div>

          <TextField
            label='Job ID'
            disabled
            variant='outlined'
            value={updatedJob?.jobId}
          />
          <TextField
            label='Company Name'
            variant='outlined'
            value={updatedJob?.companyName}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return { ...prev, companyName: e.target.value };
              })
            }
          />
          <TextField
            label='Title'
            variant='outlined'
            value={updatedJob?.title}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return { ...prev, title: e.target.value };
              })
            }
          />
          <TextField
            select
            label='Location (company)'
            name='location'
            variant='outlined'
            required
            defaultValue={updatedJob?.location}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return { ...prev, location: e.target.value };
              })
            }
          >
            {filtersOptions?.locations?.map((singleLocation, index) => {
              return (
                <MenuItem value={singleLocation} key={index}>
                  {singleLocation}
                </MenuItem>
              );
            })}
          </TextField>

          <TextField
            select
            label='Location (job)'
            name='locationJob'
            variant='outlined'
            required
            defaultValue={updatedJob?.locationRequirement}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return { ...prev, locationRequirement: e.target.value };
              })
            }
          >
            {filtersOptions?.jobLocations?.map((singleJobLocation, index) => {
              return (
                <MenuItem value={singleJobLocation} key={index}>
                  {singleJobLocation}
                </MenuItem>
              );
            })}
          </TextField>
          <TextField
            select
            label='Employment Types'
            name='employmentTypes'
            variant='outlined'
            required
            defaultValue={updatedJob?.employmentTypes}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return { ...prev, employmentType: e.target.value };
              })
            }
            // onChange={(e) => setCourseType(e.target.value)}
          >
            {filtersOptions?.employmentTypes?.map(
              (singleEmploymentType, index) => {
                return (
                  <MenuItem value={singleEmploymentType} key={index}>
                    {singleEmploymentType}
                  </MenuItem>
                );
              }
            )}
          </TextField>
          <TextField
            select
            label='Domain'
            name='domain'
            variant='outlined'
            required
            defaultValue={updatedJob?.domain}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return { ...prev, domain: e.target.value };
              })
            }
            // onChange={(e) => setCourseType(e.target.value)}
          >
            {filtersOptions?.domains?.map((singleDomain, index) => {
              return (
                <MenuItem value={singleDomain} key={index}>
                  {singleDomain}
                </MenuItem>
              );
            })}
          </TextField>
          <TextField
            label='Minimum Experience'
            variant='outlined'
            value={updatedJob?.minExperienceRequired}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return {
                  ...prev,
                  minExperienceRequired: parseInt(e.target.value),
                };
              })
            }
          />
          <TextField
            label='Maximum Experience'
            variant='outlined'
            value={updatedJob?.maxExperienceRequired}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return {
                  ...prev,
                  maxExperienceRequired: parseInt(e.target.value),
                };
              })
            }
          />
          <TextField
            label='Minimum Salary (In Rupees)'
            variant='outlined'
            value={updatedJob?.minSalary}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return {
                  ...prev,
                  minSalary: parseInt(e.target.value),
                };
              })
            }
          />
          <TextField
            label='Maximum Salary (In Rupees)'
            variant='outlined'
            value={updatedJob?.maxSalary}
            onChange={(e) =>
              setUpdatedJob((prev) => {
                return {
                  ...prev,
                  maxSalary: parseInt(e.target.value),
                };
              })
            }
          />
          <div className='col-span-2'>
            <StringArrayInput
              updatedJob={updatedJob}
              setUpdatedJob={setUpdatedJob}
            />
          </div>
        </div>

        <div className='flex justify-center'>
          <div
            className='px-8 py-2 mb-6 text-center bg-brand-primary text-white inline-block rounded-md cursor-pointer'
            onClick={handleUpdateJob}
          >
            Update Job
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

export default UpdateJobModal;
